"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isFreeCancellation = void 0;
var isFreeCancellation = exports.isFreeCancellation = function isFreeCancellation(cancellationPolicy) {
  if (cancellationPolicy && cancellationPolicy.kind === 'flexible' && cancellationPolicy.description) {
    return true;
  }
  return false;
};